export default __webpack_public_path__ + "static/media/ranking-exp-deduction-step1.b482fd8d.png";